import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sanitizePhone, isValidPhone, PHONE_ERROR } from '../utils/phone';

const AMBER = '#F5A800';

export function WhatsAppFloat() {
  const location = useLocation();
  const [showForm, setShowForm] = useState(false);
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const WA_ICON_SM = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );

  const getAutoInfo = () => {
    const ua = navigator.userAgent;
    const device   = /Mobile|Android|iPhone/i.test(ua) ? 'Mobile' : 'Desktop';
    const browser  = /Chrome/i.test(ua)  ? 'Chrome'
                   : /Safari/i.test(ua)  ? 'Safari'
                   : /Firefox/i.test(ua) ? 'Firefox'
                   : 'Other';
    const referrer = document.referrer
                   ? new URL(document.referrer).hostname
                   : 'Direct';
    const source   = referrer.includes('google')    ? 'Google'
                   : referrer.includes('instagram')  ? 'Instagram'
                   : referrer.includes('facebook')   ? 'Facebook'
                   : referrer.includes('whatsapp')   ? 'WhatsApp Share'
                   : referrer === 'Direct'            ? 'Direct'
                   : referrer;
    return { device, browser, source, referrer };
  };

  const saveLead = async (phoneNum, nameStr) => {
    const info = getAutoInfo();
    const pageName = location.pathname.replace('/', '') || 'Home';
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:    nameStr  || 'WhatsApp Visitor',
          phone:   phoneNum || 'Not provided',
          email:   '',
          source:  'WhatsApp',
          message: `WhatsApp enquiry\nPage: ${location.pathname}\nDevice: ${info.device}\nBrowser: ${info.browser}\nCame from: ${info.source}`,
          status:  'new',
          tags:    ['WhatsApp', info.device, info.source],
          notes:   `Auto-captured: ${new Date().toLocaleString('en-IN', { timeZone:'Asia/Kolkata' })} | Page: ${pageName} | Device: ${info.device} | Source: ${info.source}`,
        })
      });
    } catch {}
  };

  const openWhatsApp = () => {
    const pageMsg = `Hi Wedoo Interiors! I am interested in your interior design services. (Enquiry from: ${location.pathname})`;
    window.open(
      `https://api.whatsapp.com/send?phone=919686583195&text=${encodeURIComponent(pageMsg)}`,
      '_blank'
    );
  };

  const handleSubmit = async () => {
    if (phone.trim()) {
      if (!isValidPhone(phone)) {
        setPhoneError(PHONE_ERROR);
        return;
      }
    }
    setPhoneError('');
    setSaving(true);
    try { await saveLead(phone, name); } catch {}
    setSaving(false);
    setShowForm(false);
    openWhatsApp();
  };

  const handleSkip = () => {
    saveLead('', '').catch(() => {});
    setShowForm(false);
    openWhatsApp();
  };

  return (
    <>
      {/* Lead Capture Sheet — same flow as the mobile WhatsApp button */}
      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.88)', zIndex:2000, display:'flex', alignItems:'flex-end', justifyContent:'center' }}
          onClick={() => setShowForm(false)}>
          <div onClick={e => e.stopPropagation()}
            style={{ background:'#111', borderRadius:'20px 20px 0 0', padding:'1.5rem 1.5rem 2rem', width:'100%', maxWidth:'420px', borderTop:`3px solid ${AMBER}` }}>

            <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'1.2rem' }}>
              <div style={{ width:'42px', height:'42px', background:'#25D366', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                {WA_ICON_SM}
              </div>
              <div style={{ flex:1 }}>
                <p style={{ color:'#fff', fontWeight:'600', fontSize:'0.95rem', margin:0 }}>Chat on WhatsApp</p>
                <p style={{ color:'#666', fontSize:'0.72rem', margin:0 }}>Optional: share your number for callback</p>
              </div>
              <button onClick={() => setShowForm(false)}
                style={{ background:'none', border:'none', color:'var(--muted)', fontSize:'1.3rem', cursor:'pointer', padding:'4px' }}>✕</button>
            </div>

            <div style={{ display:'flex', flexDirection:'column', gap:'0.65rem', marginBottom:'1rem' }}>
              <div>
                <div style={{ position:'relative' }}>
                  <span style={{ position:'absolute', left:'1rem', top:'50%', transform:'translateY(-50%)', color:'#888', fontSize:'0.9rem' }}>+91</span>
                  <input
                    placeholder="10-digit mobile number (optional)"
                    type="tel"
                    maxLength={10}
                    value={phone}
                    onChange={e => {
                      const val = sanitizePhone(e.target.value);
                      setPhone(val);
                      if (phoneError) setPhoneError('');
                    }}
                    style={{
                      width:'100%', padding:'0.75rem 1rem 0.75rem 3rem',
                      background:'#1a1a1a',
                      border: phoneError ? '1px solid #ef4444' : '1px solid #333',
                      borderRadius:'8px', color:'#fff', fontSize:'0.9rem',
                      outline:'none', boxSizing:'border-box',
                    }}
                  />
                </div>
                {phoneError && (
                  <p style={{ color:'#ef4444', fontSize:'0.72rem', margin:'4px 0 0 4px' }}>
                    ⚠ {phoneError}
                  </p>
                )}
                {phone.length > 0 && !phoneError && (
                  <p style={{ color: phone.replace(/\D/g,'').length === 10 ? '#22c55e' : '#888', fontSize:'0.7rem', margin:'4px 0 0 4px' }}>
                    {phone.replace(/\D/g,'').length}/10 digits
                    {phone.replace(/\D/g,'').length === 10 ? ' ✓' : ''}
                  </p>
                )}
              </div>
            </div>

            <button onClick={handleSubmit} disabled={saving}
              style={{ width:'100%', padding:'0.9rem', background:'#25D366', border:'none', borderRadius:'10px', color:'#fff', fontSize:'1rem', fontWeight:'600', cursor:'pointer', marginBottom:'0.6rem', display:'flex', alignItems:'center', justifyContent:'center', gap:'0.5rem' }}>
              {saving ? 'Connecting...' : <>{WA_ICON_SM} Start WhatsApp Chat</>}
            </button>

            <button onClick={handleSkip}
              style={{ width:'100%', padding:'0.65rem', background:'transparent', border:'none', color:'var(--muted)', fontSize:'0.8rem', cursor:'pointer' }}>
              Skip &amp; chat directly →
            </button>
          </div>
        </div>
      )}

      <button onClick={() => setShowForm(true)}
        className="wa-float" aria-label="Chat on WhatsApp"
        style={{ border:'none', padding:0, cursor:'pointer' }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </button>
    </>
  );
}

export function ScrollTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const h = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);
  if (!show) return null;
  return (
    <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="scroll-top" aria-label="Scroll to top">↑</button>
  );
}

export default WhatsAppFloat;
